// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3d9AG","header":"ReportDetails_header__3u0ux","title":"ReportDetails_title__2oceV","left":"ReportDetails_left__2O-vG"};